export default __webpack_public_path__ + "static/media/Potato-bag-smaller.59df0bfd.png";